

export class StateValues {
    public static readonly STATE_CREATING_ATTACHMENT_VOID = "0_void";          // the UI is not creating an attachment
    public static readonly STATE_CREATING_ATTACHMENT_GETTING_COORD = "1_getting_coord"; // the UI is waiting on the user to enter a position on the map
    public static readonly STATE_CREATING_ATTACHMENT_GETTING_FILE = "2a_getting_file";  // the ui is waiting on the user to send a file
    public static readonly STATE_CREATING_ATTACHMENT_GETTING_URL = "2b_getting_link";  // the ui is waiting on the user to enter a URL
    public static readonly STATE_CREATING_ATTACHMENT_SAVING_FILE = "3_saving_file";   // the UI is busy reading the file
    public static readonly STATE_CREATING_ATTACHMENT_API_BUSY = "4_api_busy";      // the createattachemnt is API is working
}

export class Keys {

    public static readonly HASH_BUILDINGS_DATA: string = "BUILDINGS_DATA_HASH"
    public static readonly HARD_CODED_MAP_URL: string = "hard_coded_map_url"
    public static readonly IS_FETCHING_ASSETS: string = "fetching_assets"
    public static readonly IS_FETCHING_ATTACHMENTS: string = "fetching_attachments"
    public static readonly IS_HARD_CODED_MAP: string = "hard_coded_map"
    public static readonly IS_PAGE_CURRENTLY_SITEMAP: string = "state_is_page_currently_sitemap"
    public static readonly WORKORDERS_QUERY: string = "workorders_query"

    public static readonly DATA_FINDINGS: string = "DATA_FINDINGS"
    public static readonly DOWNLOADED_FINDINGS_FLOORS: string = "DOWNLOADED_FINDINGS_FLOORS"
    public static readonly ENABLED_FEATURE_ASSETS: string = "ENABLED_FEATURE_ASSETS"

    public static readonly ENABLED_FEATURE_ATTACHMENTS: string = "ENABLED_FEATURE_ATTACHMENTS"
    public static readonly ENABLED_FEATURE_FINDINGS: string = "ENABLED_FEATURE_FINDINGS"
    public static readonly ENABLED_FEATURE_SPOTSHADOW: string = "ENABLED_FEATURE_SPOTSHADOW"
    public static readonly ENABLED_FEATURE_READONLY_MODE: string = "ENABLED_FEATURE_READONLY_MODE"


    public static readonly ALLOW_3D_LINK_CREATE: string = "ALLOW_3D_LINK_CREATE"
    public static readonly ALLOW_PHOTO_ATTACHMENT_CREATE: string = "ALLOW_PHOTO_ATTACHMENT_CREATE"
    //public static readonly API_TOKEN: string = "api_token";

    // When in an add attachment state, this is the new attachment object being created
    public static readonly KEY_ADD_ATTACHMENT_OBJECT: string = 'KEY_ADD_ATTACHMENT_OBJECT';
    //    public static readonly KEY_MENU_FLOORPLANS_CONTENT: string = "menu_floorplans_content";
    public static readonly MENU_FLOORPLANS_EXPANDED: string = "menu_floorplans_expanded";

    public static readonly KEY_MOUSE_CURSOR: string = 'mouse_cursor';


    // attachment API states
    //   these states indicate that there is an active API call that hasn't returned yet
    public static readonly KEY_STATE_API_DELETEATTACHMENT: string = 'STATE_API_DELETEATTACHMENT';
    public static readonly KEY_STATE_API_CREATEATTACHMENT: string = 'STATE_API_CREATEATTACHMENT';
    public static readonly KEY_STATE_API_UPDATEATTACHMENT: string = 'STATE_API_UPDATEATTACHMENT';
    public static readonly KEY_STATE_API_DRAWINGLOCATIONS_B: string = 'STATE_API_DRAWINGLOCATIONS_B';

    public static readonly KEY_STATE_FIRST_RUN: string = 'KEY_STATE_FIRST_RUN';

    public static readonly STATE_CREATING_ATTACHMENT: string = 'STATE_CREATING_ATTACHMENT'; // is set to one of the follwing value_creating_attachment values
    public static readonly STATE_CREATING_ASSET: string = 'STATE_CREATING_ASSET';
    public static readonly STATE_CREATING_FINDING: string = 'STATE_CREATING_FINDING';
    public static readonly STATE_CREATING_WORKORDER: string = 'STATE_CREATING_WORKORDER';
    public static readonly STATE_FETCHING_FINDINGS: string = 'STATE_FETCHING_FINDINGS';
    public static readonly STATE_PRINTING_FINDINGS: string = 'STATE_PRINTING_FINDINGS';


    // UI States: These are UI states that cause modals to appear and get additional user input
    //   add attachment get file
    //   add attachment get coordinates
    public static readonly KEY_STATE_UI_CREATEATTACHMENT_GET_FILE: string = 'STATE_UI_CREATEATTACHMENT_GET_FILE';
    public static readonly KEY_STATE_UI_CREATEATTACHMENT_GET_LINK: string = 'STATE_UI_CREATEATTACHMENT_GET_LINK';
    public static readonly KEY_STATE_UI_CREATEATTACHMENT_GET_COORD: string = 'STATE_UI_CREATEATTACHMENT_GET_COORD';

    public static readonly KEY_STATE_UI_CREATEPUSHPIN_GET_COORD: string = 'STATE_UI_CREATEPUSHPIN_GET_COORD';

    public static readonly ATTACHMENT_TYPE: string = 'ATTACHMENT_TYPE';  // 'image', 'url', 'video', or ...
    public static readonly ATTACHMENTS_DATA_HASH: string = 'attachments_data_hash';  // 'image', 'url', 'video', or ...


    public static readonly KEY_INITIAL_ID_BUILDING: string = "initial_id_building";//, initial_id_building);
    public static readonly KEY_INITIAL_ID_FLOOR: string = "initial_id_floor";// , initial_id_floor);

    public static readonly KEY_IS_IOS_DEVICE: string = "is_ios_device";
    public static readonly KEY_DATA_ALL_ATTACHMENTS: string = 'data_all_attachments';
    public static readonly DATA_ASSETS: string = "data_assets";  // all data assets
    public static readonly CURRENT_FLOOR_ASSETS: string = "current_floor_assets";  // all data assets
    public static readonly DATA_ASSET_IDS: string = "data_asset_ids";
    public static readonly DATA_ASSETS_RAW_LAST_UPDATED: string = "data_assets_raw_last_updated"   // the timestap of the last time that assets data was received
    //public static readonly DATA_BUILDINGS: string = "data_buildings";

    public static readonly DATA_WORKORDERS: string = "data_workorders";
    public static readonly DATA_WORKORDERS_JSON: string = "data_workorders";

    public static readonly KEY_DATA_CATEGORIES: string = "data_categories";
    public static readonly KEY_DATA_CATEGORIES_RAW: string = "data_categories_raw";

    public static readonly HASH_DATA_FLOORPLANS: string = "data_floorplans_hash";
    public static readonly KEY_DATA_SITEMAP: string = "data_sitemap";
    public static readonly KEY_DATA_DRAWING_LOCATION_MAP: string = "data_drawing_location_map"
    public static readonly KEY_DATA_PUSHPIN_COORDS: string = "data_pushpin_coords";
    public static readonly KEY_BUILD_ID: string = "build_id";

    public static readonly MENU_ASSETS_CONTENT: string = "menu_assets_content"
    public static readonly KEY_MENU_ATTACHMENTS_CONTENT = "menu_attachments_content";

    public static readonly MENU_WORKORDERS_CONTENT: string = "menu_workorders_content"
    public static readonly MENU_WORKORDERS_EXPANDED: string = "menu_workorders_expanded"
    public static readonly MENU_WORKORDERS_SELECTED: string = "menu_workorders_selected"
    public static readonly KEY_MENU_ATTACHMENTS_SELECTED: string = "menu_attachments_selected";
    public static readonly KEY_MENU_PUSHPIN_SELECTED: string = "menu_pushpin_selected";
    public static readonly KEY_BUILDING_WO_COUNT: string = "building_wo_count";
    public static readonly KEY_SHOW_PUSHPIN_BUTTON: string = "show_pushpin_button";

    public static readonly SITEMAP_URL: string = "sitemap_url";
    public static readonly KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP : string = "is_page_currently_sitemap";
    public static readonly KEY_STATE_SITEMAP_AVAILABLE : string = "is_sitemap_available";
    public static readonly HASH_DRAWINGS_INFO_DATA: string = "drawings_info_data_hash";

    public static readonly KEY_DOWNLOADED_ATTACHMENT_FLOORS:string = "downloaded_attachment_floors";
    public static readonly MENU_ASSETS_EXPANDED: string = "menu_assets_expanded"
    public static readonly MENU_ASSETS_SELECTED: string = "menu_assets_selected"
    public static readonly MENU_ATTACHMENTS_EXPANDED: string = "menu_attachments_expanded"
    public static readonly MENU_BUILDINGS_EXPANDED: string = "menu_buildings_expanded"
    public static readonly MENU_BUILDINGS_SHOW: string = "menu_buildings_show"

    public static readonly MENU_FINDINGS_EXPANDED: string = "menu_findings_expanded"
    public static readonly MENU_FINDINGS_SELECTED: string = "MENU_FINDINGS_SELECTED"
    public static readonly MENU_FINDINGS_CONTENT: string = "MENU_FINDINGS_CONTENT"
    public static readonly MENU_FLOORS_EXPANDED: string = "menu_floors_expanded"
    

    public static readonly API_GATEWAY: string = "api_gateway";
	public static readonly STORAGE_ACCOUNT_URL: string = "storage_account_url";
    public static readonly BUILDING_P1P2: string = "building_p1p2";
    public static readonly CUSTOMER_NAME: string = "customer_name";
    public static readonly DEBUG_ENABLED: string = "debug_enabled";
    public static readonly DRAWING_HISTORY: string = "floor_drawing_history";
    public static readonly DRAWING_P1P2: string = "drawing_p1p2"
    public static readonly DRAWING_P0: string = "drawing_p0"
    public static readonly SUPPORTED_BROWSER: string = "supported_browser";


    public static readonly ID_BUILDING: string = "id_building"
    public static readonly ID_DRAWING: string = "id_drawing"
    public static readonly ID_CUSTOMER: string = "id_customer";
    public static readonly ID_FLOOR: string = "id_floor"
    public static readonly ID_SEGMENT: string = "id_segment";
    public static readonly LOCATION_DESCRIPTION: string = "location_description";
    public static readonly TILES_URL: string = "tiles_url"
    public static readonly Z_INDEX: string = "z_index";
    public static readonly TOKEN_IS_BAD: string = "token_is_bad";

}

export function APP_KEYS(): string[] {
    return [
        Keys.ALLOW_3D_LINK_CREATE,
        Keys.ALLOW_PHOTO_ATTACHMENT_CREATE,
        Keys.API_GATEWAY,
        Keys.ATTACHMENT_TYPE,
        Keys.ATTACHMENTS_DATA_HASH,
        Keys.BUILDING_P1P2,
        Keys.CURRENT_FLOOR_ASSETS,
        Keys.CUSTOMER_NAME,
        Keys.DATA_ASSET_IDS,
        Keys.DATA_ASSETS_RAW_LAST_UPDATED,
        Keys.DATA_ASSETS,
        Keys.DATA_FINDINGS,
        Keys.DATA_WORKORDERS_JSON,
        Keys.DATA_WORKORDERS,
        Keys.DEBUG_ENABLED,
        Keys.DOWNLOADED_FINDINGS_FLOORS,
        Keys.DRAWING_HISTORY,
        Keys.DRAWING_P0,
        Keys.DRAWING_P1P2,
        Keys.ENABLED_FEATURE_ASSETS,
        Keys.ENABLED_FEATURE_ATTACHMENTS,
        Keys.ENABLED_FEATURE_FINDINGS,
        Keys.ENABLED_FEATURE_READONLY_MODE,
        Keys.ENABLED_FEATURE_SPOTSHADOW,
        Keys.HARD_CODED_MAP_URL,
        Keys.HASH_BUILDINGS_DATA,
        Keys.HASH_DATA_FLOORPLANS,
        Keys.HASH_DRAWINGS_INFO_DATA,
        Keys.ID_BUILDING,
        Keys.ID_CUSTOMER,
        Keys.ID_DRAWING,
        Keys.ID_FLOOR,
        Keys.ID_SEGMENT,
        Keys.IS_FETCHING_ASSETS,
        Keys.IS_FETCHING_ATTACHMENTS,
        Keys.IS_HARD_CODED_MAP,
        Keys.IS_PAGE_CURRENTLY_SITEMAP,
        Keys.KEY_ADD_ATTACHMENT_OBJECT,
        Keys.KEY_BUILDING_WO_COUNT,
        Keys.KEY_DATA_ALL_ATTACHMENTS,
        Keys.KEY_DATA_CATEGORIES_RAW,
        Keys.KEY_DATA_CATEGORIES,
        Keys.KEY_DATA_DRAWING_LOCATION_MAP,
        Keys.KEY_DATA_PUSHPIN_COORDS,
        Keys.KEY_DATA_SITEMAP,
        Keys.KEY_DOWNLOADED_ATTACHMENT_FLOORS,
        Keys.KEY_INITIAL_ID_BUILDING,
        Keys.KEY_INITIAL_ID_FLOOR,
        Keys.KEY_IS_IOS_DEVICE,
        Keys.KEY_MENU_ATTACHMENTS_CONTENT,
        Keys.KEY_MENU_ATTACHMENTS_SELECTED,
        Keys.KEY_MENU_PUSHPIN_SELECTED,
        Keys.KEY_MOUSE_CURSOR,
        Keys.KEY_SHOW_PUSHPIN_BUTTON,
        Keys.KEY_STATE_API_CREATEATTACHMENT,
        Keys.KEY_STATE_API_DELETEATTACHMENT,
        Keys.KEY_STATE_API_DRAWINGLOCATIONS_B,
        Keys.KEY_STATE_API_UPDATEATTACHMENT,
        Keys.KEY_STATE_FIRST_RUN,
        Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_COORD ,
        Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_FILE ,
        Keys.KEY_STATE_UI_CREATEATTACHMENT_GET_LINK  ,
        Keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD ,
        Keys.LOCATION_DESCRIPTION ,
        Keys.MENU_ASSETS_CONTENT ,
        Keys.MENU_ASSETS_EXPANDED ,
        Keys.MENU_ASSETS_SELECTED ,
        Keys.MENU_ATTACHMENTS_EXPANDED, 
        Keys.MENU_BUILDINGS_EXPANDED ,
        Keys.MENU_BUILDINGS_SHOW ,
        Keys.MENU_FINDINGS_CONTENT, 
        Keys.MENU_FINDINGS_EXPANDED, 
        Keys.MENU_FINDINGS_SELECTED ,
        Keys.MENU_FLOORPLANS_EXPANDED, 
        Keys.MENU_FLOORS_EXPANDED ,
        Keys.MENU_WORKORDERS_CONTENT, 
        Keys.MENU_WORKORDERS_EXPANDED, 
        Keys.MENU_WORKORDERS_SELECTED ,
        Keys.SITEMAP_URL ,
        Keys.STATE_CREATING_ASSET ,
        Keys.STATE_CREATING_ATTACHMENT ,
        Keys.STATE_CREATING_FINDING ,
        Keys.STATE_CREATING_WORKORDER, 
        Keys.STATE_FETCHING_FINDINGS ,
        Keys.STATE_PRINTING_FINDINGS,
        Keys.SUPPORTED_BROWSER ,
        Keys.TILES_URL ,
        Keys.TOKEN_IS_BAD ,
        Keys.WORKORDERS_QUERY ,
        Keys.Z_INDEX 

    ];
}


// WEBPACK FOOTER //
// ./src/ts/redux/Datastore.ts